import { Component, HostListener, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { UbicacionesService } from '../../service/ubicaciones.service';
import { SeoService } from '../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';

declare let L: { icon: (arg0: { iconUrl: string; iconSize: number[]; iconAnchor: number[]; shadowAnchor: number[]; popupAnchor: number[]; }) => any; map: (arg0: string) => { (): any; new(): any; setView: { (arg0: number[], arg1: number): any; new(): any; }; }; tileLayer: (arg0: string, arg1: { attribution: string; }) => { (): any; new(): any; addTo: { (arg0: any): void; new(): any; }; }; marker: (arg0: any[], arg1: { icon: any; }) => { (): any; new(): any; addTo: { (arg0: any): { (): any; new(): any; bindPopup: { (arg0: string): { (): any; new(): any; getCenter: { (): any; new(): any; }; }; new(): any; }; }; new(): any; }; }; circle: (arg0: number[], arg1: { color: string; fillColor: string; fillOpacity: number; radius: number; }) => { (): any; new(): any; addTo: { (arg0: any): void; new(): any; }; }; };

@Component({
  selector: 'app-consultorios',
  templateUrl: './consultorios.component.html',
  styleUrls: ['./consultorios.component.css']
})
export class ConsultoriosComponent implements OnInit {

  private subscription: Subscription = new Subscription();
  estadoId: any;
  estadoIdg: any;
  ciudadId: any;
  procedimientos: any;
  estados: any;
  ciudades: any;
  consultorios: any;
  munnombre: any;
  dont = false;
  okmun = false;
  espec= false;
  dataesp : any;
  geopotitonok= false;

  //latLng = [23.6345005, -102.5527878];
  lat =23.6345005;
  lng=-102.5527878;
  hidden = false;
  isIE = false;
  innerHeight!: number;
  mapHeight: any;
  mapStyle: any;
  selectedUnidad: any;
  map: any;
  sub: any;
  page: any;
  icon: any;
  all = true;
  isLocated = false;
  markers: any;
  markerarr= new Array();
  array= new Array();
  zoom: number;
  unidades: any;
  composer: any;
  theMarker: any;
  showpro=false;
  icons: any;
  latitudup: any;
  latituddow: any;
  longitudup: any;
  longituddow: any;
  activo: any;

  RouteText : any;
  tituloseo: any;
  urlcanonicaseo: any;
  imagenseo: any;
  keywordsseo: any;
  descripcionseo: any;

  constructor(
    private _ubicacionesService: UbicacionesService,
    private meta: Meta,
    private title: Title,
    private _seoService: SeoService,
    private router: Router,
    private _urlcanonicaservice: UrlcanonicaService

  ) {

    this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.RouteText = event;
      this.getSEO(event.url)
    });

    this.innerHeight = window.innerHeight;

    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(
      window.navigator.userAgent
    );

    if (isIEOrEdge) {
      this.mapHeight = this.innerHeight - 100;
      this.isIE = true;
      this.mapStyle = {
        'background-color': 'grey',
        'min-height': this.mapHeight + 'px',
        'max-height': this.mapHeight + 'px'
      };
    }
    this.zoom = 5;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerHeight = window.innerHeight;
  }

	ngOnInit(): void {
		this.getEstados();
		this.gomap();
	}

	gomap() {

		this.icon = L.icon({
		iconUrl: 'assets/images/location_medico.png',
		iconSize: [35, 35], // size of the icon
		iconAnchor: [16, 38], // point of the icon which will correspond to marker's location
		shadowAnchor: [4, 62], // the same for the shadow
		popupAnchor: [3, -50] // point from which the popup should open relative to the iconAnchor
		});


		this.icons = L.icon({
		iconUrl: 'assets/images/location_usuario.png',
		iconSize: [35, 35], // size of the icon
		iconAnchor: [16, 38], // point of the icon which will correspond to marker's location
		shadowAnchor: [4, 62], // the same for the shadow
		popupAnchor: [3, -50] // point from which the popup should open relative to the iconAnchor
		});

		this.map = L.map('map').setView([23.6345005, -102.5527878], this.zoom);

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution:
			'© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		}).addTo(this.map);

		this.setPosition();
	}

	geocodeAddress() {
		this.setPosition();
	}

	setView(lat: number, lng: number) {
		this.zoom = 17;
		//this.latLng = [lat, lng];
		this.map.setView(this.lat, this.lng, this.zoom);
		if (this.theMarker != undefined) {
		this.map.removeLayer(this.theMarker);

		};
		this.geopotitonok = true;
		this.theMarker = L.marker([lat, lng], { icon: this.icon }).addTo(this.map);
	}


	capitalizeFirstLetter(str: string) {
		var splitStr = str.toLowerCase().split(' ');
		for (var i = 0; i < splitStr.length; i++) {
			splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLocaleLowerCase();
		}
		return splitStr.join(' ');
	}

	setPosition() {
		if (!this.isLocated) {
		this.isLocated = true;
		navigator.geolocation.getCurrentPosition(
			e => {

			this.lat= e.coords.latitude;
			this.lng= e.coords.longitude;
			this.latitudup = e.coords.latitude-(0.01);
			this.latituddow = e.coords.latitude+(0.01);
			this.longitudup = e.coords.longitude-(0.01);
			this.longituddow = e.coords.longitude+(0.01);

			this.subscription.add(
				this._ubicacionesService.getPosicionMedico(this.latitudup,this.latituddow, this.longitudup, this.longituddow).subscribe((resp: any) => {
				if(resp.length > 0){
					this.okmun = true;
					this.dont = false;
					this.zoom = 17;
					resp.forEach((element: { latitud: any; longitud: any; unidad: any; calle: any; numeroExterior: any;  numeroInterior: any; codigoPostal: any; colonia: any;}) => {

					if(element.numeroExterior.length == 0){element.numeroExterior="S/N";}
					if(element.numeroInterior.length == 0){element.numeroInterior="S/N";}
					element.calle = this.capitalizeFirstLetter(element.calle);
					element.colonia = this.capitalizeFirstLetter(element.colonia);
					this.markers = L.marker([element.latitud, element.longitud], { icon: this.icon })
						.addTo(this.map)
						.bindPopup(`
						<p">Calle: ${element.calle}</p>
						<p">Número Exterior: ${element.numeroExterior}</p>
						<p">Número Interior: ${element.numeroInterior}</p>
						<p">Código Postal: ${element.codigoPostal}</p>
						<p">Colonia: ${element.colonia}</p>
						`);

					this.markerarr.push(this.markers)
					});
				}else{
					this.dont = true;
					this.okmun = false;
					this.espec = false;
				}

				})
			);

			this.map.flyTo([this.lat, this.lng], 15);
			L.circle([this.lat, this.lng], {
				color: '#82b1ff',
				fillColor: '#90caf9',
				fillOpacity: 0.4,
				radius: 900
			}).addTo(this.map);
			this.theMarker =  L.marker([e.coords.latitude, e.coords.longitude], { icon: this.icons }).addTo(this.map);
			this.geopotitonok = true;

			},
			error => {
			if (error.code === 1) {
				console.warn('Bloqueo el GeoLocation');
				this.hidden = true;
				this.geopotitonok = false;
			}
			}
		);
		} else {
		//this.map.setView(this.currentCoords, 14);
		}
	}

	getEstados() {
		this.subscription.add(
		this._ubicacionesService.getEstados().subscribe((resp: any) => {
			this.estados = resp;

		})
		);
	}

	getCiudades(estadoId: number) {
		this.estadoIdg = estadoId;
		this.dont = false;
		this.espec = false;
		this.showpro= false;
		this.okmun = false;
		this.geopotitonok = false;
		this.subscription.add(
		this._ubicacionesService.getCiudades(estadoId).subscribe((resp: any) => {
			this.ciudades = resp;

		})
		);
	}

	selectCiudad(event: any) {
		this.geopotitonok = false;
		this.dont = false;
		this.espec = false;
		this.okmun = false;
		this.showpro= false;
		this.selectSucursal(event)
	}

	selectSucursal(sucursal: any) {
		this.munnombre = sucursal.nombre;
		this.consultorios='';
		this.subscription.add(
		this._ubicacionesService.getSucursalesMedicas(sucursal.idMunicipio).subscribe((resp: any) => {
      console.log(resp);
			if(resp.length > 0){
			if(this.markerarr){
				for(var i=0;i<this.markerarr.length; i++) {
				this.map.removeLayer(this.markerarr[i]);
				}
			}
			this.showpro=true;
			this.geopotitonok = true;
			this.consultorios = resp;
			resp.reverse();
			resp.forEach((element: { latitud: any; longitud: any; unidad: any; calle: any; numeroExterior: any;  numeroInterior: any; codigoPostal: any; colonia: any;}) => {

				if(element.numeroExterior.length == 0){element.numeroExterior="S/N";}
				if(element.numeroInterior.length == 0){element.numeroInterior="S/N";}
				element.calle = this.capitalizeFirstLetter(element.calle);
				element.colonia = this.capitalizeFirstLetter(element.colonia);
				this.markers = L.marker([element.latitud, element.longitud], { icon: this.icon })
				.addTo(this.map)
				.bindPopup(`
					<p">Calle: ${element.calle}</p>
					<p">Número Exterior: ${element.numeroExterior}</p>
					<p">Número Interior: ${element.numeroInterior}</p>
					<p">Código Postal: ${element.codigoPostal}</p>
					<p">Colonia: ${element.colonia}</p>
				`);

				this.markerarr.push(this.markers)
				this.map.flyTo([element.latitud, element.longitud], 13);
			});

			this.procedimientos = [];
			this.subscription.add(
				this._ubicacionesService.getProcedimientosMedicas(this.estadoIdg, this.munnombre).subscribe((resp: any) => {
				this.procedimientos = [].concat(resp.slice(4,5), resp.slice(3,4), resp.slice(5,6), resp.slice(2,3), resp.slice(0,1), resp.slice(7,resp.length));
				this.activo =true;
				})
			);
			}else{
			this.dont = true;
			this.okmun = false;
			this.espec = false;
			}

		})
		);
	}

	getColor(tecnica: string){

		if (tecnica === 'CONSULTA MEDICA') {
			return '#4CA7D4';
		} else if (tecnica === 'CONSULTA DOMINICAL') {
			return '#4CA7D4';
		} else if (tecnica === 'CONSULTA NOCTURNA') {
			return '#4CA7D4';
		} else if (tecnica === 'CONSULTA DIAS FESTIVOS') {
			return '#4CA7D4';
		} else if (tecnica === 'CONSULTA') {
			return '#4CA7D4';
		}else {
			// Falta el color a devolver cuando no sea ninguno de esos casos!
			return null
		}
	}

	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
		  console.log(resp)
		  if (resp != null) {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.imagen;

			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({
			  name: 'description',
			  content: this.descripcionseo
			})

			this.meta.updateTag({
			  property: 'twitter:card',
			  content: 'summary'
			})
			this.meta.updateTag({
			  property: 'twitter:site',
			  content: '@fundacionbest'
			})
			this.meta.updateTag({
			  property: 'twitter:title',
			  content: 'Fundación BEST'
			})
			this.meta.updateTag({
			  property: 'twitter:description',
			  content: this.descripcionseo
			})
			this.meta.updateTag({
			  property: 'twitter:image',
			  content: this.imagenseo
			})

			this.meta.updateTag({
			  property: 'og:url',
			  content: 'https://fundacionbest.org.mx/servicios'
			})
			this.meta.updateTag({
			  property: 'og:title',
			  content: this.tituloseo
			})
			this.meta.updateTag({
			  property: 'og:image',
			  content: this.imagenseo
			})
			this.meta.updateTag({
			  property: 'og:description',
			  content: this.descripcionseo
			})
		  }

		});
	  }

}
